

export class AddSubMenuInput implements IAddSubMenuInput {
    /** The auto-generated id of the tbl_application_menu */
    applicationMenuId!: number;
    /** The sub menu name with 100 character limit */
    menuName!: string;
    /** The sub menu icon with 2048 character limit */
    menuURL!: string;
    /** The sub menu type must be "OVERVIEW" or "DETAIL" */
    screenType!: string;
    /** The index_number */
    indexNumber!: number;

    constructor(data?: IAddSubMenuInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationMenuId = _data["applicationMenuId"];
            this.menuName = _data["menuName"];
            this.menuURL = _data["menuURL"];
            this.screenType = _data["screenType"];
            this.indexNumber = _data["indexNumber"];
        }
    }

    static fromJS(data: any): AddSubMenuInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddSubMenuInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationMenuId"] = this.applicationMenuId;
        data["menuName"] = this.menuName;
        data["menuURL"] = this.menuURL;
        data["screenType"] = this.screenType;
        data["indexNumber"] = this.indexNumber;
        return data; 
    }
}

export interface IAddSubMenuInput {
    /** The auto-generated id of the tbl_application_menu */
    applicationMenuId: number;
    /** The sub menu name with 100 character limit */
    menuName: string;
    /** The sub menu icon with 2048 character limit */
    menuURL: string;
    /** The sub menu type must be "OVERVIEW" or "DETAIL" */
    screenType: string;
    /** The index_number */
    indexNumber: number;
}

